import { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useFlightSummarySelectedTotalPrice } from './useFlightSummarySelectedTotalPrice';
import { usePersistedFlightSelection } from './usePersistedFlightSelection/usePersistedFlightSelection';
import {
  GetFlightSummarySelectedTotalPriceQuery,
  GetFlightSummarySelectedTotalPriceQueryVariables,
} from 'generated/graphql';

export const useFlightSelectedTotalPrice = (): UseQueryResult<
  GetFlightSummarySelectedTotalPriceQuery,
  GetFlightSummarySelectedTotalPriceQueryVariables
> => {
  const [flightSelectionData = {}] = usePersistedFlightSelection();
  return useFlightSummarySelectedTotalPrice(flightSelectionData);
};
